import React from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import { photos } from '../data/site';
import { performance } from '../data/content';
import { PageIntro } from '../components/ui/PageIntro';
import { ButtonLink } from '../components/ui/ButtonLink';
import { Faq } from '../components/ui/Faq';
import { CtaBand } from '../components/ui/CtaBand';
export function Performances() {
  usePageTitle('Live optreden');
  return <>
      <PageIntro eyebrow="Optreden · feesten, borrels & vieringen" title={<>
            Live muziek die de <em className="text-amber" data-id="element-405" data-mp="3pnacggs6bmyb">zaal leest</em>.
          </>} intro="Met gitaar of piano en stem geef ik uw gelegenheid de juiste muzikale omlijsting. Ingetogen tijdens het diner, vol overgave als de zaal wil zingen — ik speel wat er op dat moment gevraagd wordt." image={{
      src: photos.stage,
      alt: 'Bas zingt live achter de microfoon',
      position: '38% 50%'
    }} data-id="element-404" data-mp="3krmt4i0dho0q">
        <ButtonLink to="/contact?type=optreden" arrow data-id="element-406" data-mp="36wsnmnagpbi8">
          Vraag beschikbaarheid aan
        </ButtonLink>
        <ButtonLink to="/repertoire" variant="outline" data-id="element-407" data-mp="3v071d3l7th0">
          Bekijk het repertoire
        </ButtonLink>
      </PageIntro>

      <section aria-labelledby="occasions-title" className="w-full bg-paper text-ink" data-id="element-408" data-mp="3q88c6ugcl8oz">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 py-24 md:px-10 lg:grid-cols-12 lg:py-32" data-id="element-409" data-mp="3l9x2qktyt07a">
          <div className="lg:col-span-4" data-id="element-410" data-mp="3h8bwhibxrk62">
            <h2 id="occasions-title" className="font-serif text-5xl leading-[1.02] tracking-tight" data-id="element-411" data-mp="3h9d9vtgfciqy">
              Voor elke gelegenheid.
            </h2>
            <p className="mt-5 max-w-sm text-[17px] leading-relaxed text-ink/70" data-id="element-412" data-mp="379cntzr67oj2">
              Klein en persoonlijk of groot en feestelijk: de muziek past zich aan het moment aan, niet andersom.
            </p>
          </div>
          <ul className="border-t border-ink/15 lg:col-span-8" data-id="element-413" data-mp="15h8070gpfde5">
            {performance.occasions.map(o => <li key={o.title} className="grid grid-cols-1 gap-2 border-b border-ink/15 py-6 sm:grid-cols-12 sm:gap-6" data-id="element-414" data-mp="10k7pudctnoh8">
                <h3 className="font-serif text-3xl leading-tight sm:col-span-6" data-id="element-415" data-mp="2uxtowrlgors9">{o.title}</h3>
                <p className="text-[16px] leading-relaxed text-ink/70 sm:col-span-6" data-id="element-416" data-mp="2zs6bvbm5cl8r">{o.text}</p>
              </li>)}
          </ul>
        </div>
      </section>

      <section aria-labelledby="steps-title" className="w-full bg-ink" data-id="element-417" data-mp="2q13985dkjy7d">
        <div className="mx-auto max-w-7xl px-5 py-24 md:px-10 lg:py-32" data-id="element-418" data-mp="3dputmakx3c9l">
          <h2 id="steps-title" className="max-w-3xl font-serif text-5xl leading-[1.02] tracking-tight text-paper md:text-6xl" data-id="element-419" data-mp="3ioz5xa351q45">
            Van eerste mail tot laatste toegift.
          </h2>
          <ol className="mt-16 grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-0" data-id="element-420" data-mp="38r1fqh1pxj8w">
            {performance.steps.map((s, i) => <li key={s.title} className="border-t border-line pt-6 md:pr-10" data-id="element-421" data-mp="1ta1ay6bu13ag" data-mpi={i}>
                <p className="font-serif text-6xl italic leading-none text-amber" data-id="element-422" data-mp="1xbmj5edf8teb">{i + 1}</p>
                <h3 className="mt-6 text-lg font-semibold text-paper" data-id="element-423" data-mp="1ps3k5yns8pk3">{s.title}</h3>
                <p className="mt-3 max-w-sm text-[16px] leading-relaxed text-sand" data-id="element-424" data-mp="1pu6hl3r9lkyu">{s.text}</p>
              </li>)}
          </ol>
        </div>
      </section>

      <section aria-label="Sfeerbeelden" className="w-full bg-ink pb-24 lg:pb-32" data-id="element-425" data-mp="1zq1acrp7cwfc">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-3 px-5 md:grid-cols-12 md:px-10" data-id="element-426" data-mp="1usrkjaxwiiqz">
          <img src={photos.guitarSmile} alt="Bas lacht en speelt gitaar buiten onder de bomen" className="aspect-[16/10] w-full rounded-sm object-cover md:col-span-8" data-id="element-427" data-mp="172nih80d2r23" />
          <img src={photos.guitarFocus} alt="Bas geconcentreerd op zijn gitaar" style={{
          objectPosition: '45% 40%'
        }} className="aspect-[16/10] w-full rounded-sm object-cover md:col-span-4 md:aspect-auto md:h-full" data-id="element-428" data-mp="1gs72wi3q2sz2" />
        </div>
      </section>

      <section aria-labelledby="perf-faq-title" className="w-full border-t border-line bg-stage" data-id="element-429" data-mp="o9jm3evre03s">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 py-24 md:px-10 lg:grid-cols-12 lg:py-32" data-id="element-430" data-mp="jc1afgqcx6s3">
          <h2 id="perf-faq-title" className="font-serif text-5xl leading-[1.02] tracking-tight text-paper lg:col-span-4" data-id="element-431" data-mp="3io7jlxs5akwv">
            Veelgestelde vragen
          </h2>
          <div className="lg:col-span-8" data-id="element-432" data-mp="3rq710r72nr0c">
            <Faq items={performance.faq} data-id="element-433" data-mp="3rp5qqoxvr8jo" />
          </div>
        </div>
      </section>

      <CtaBand title="Staat uw datum al vast?" text="Laat weten wanneer en waar, dan hoort u snel of ik beschikbaar ben — inclusief een vrijblijvende offerte." to="/contact?type=optreden" label="Vraag beschikbaarheid aan" data-id="element-434" data-mp="ee0potx2ias" />
    </>;
}